export class TestoData {

    public id_doc_master: number = 0;
    public tipo_testo: number = 1; //2 testo piatto, 1 html
    public id_unita_doc: number = 0;
    public tipo_ud: number = 5; //0 tutte, 5 solo ragionato, 37 solo sentenza
}